import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgModel } from '@angular/forms';

/**
 * Permite apenas digitos no input. Qualquer outro caractere (letras, espacos,
 * simbolos) e descartado enquanto o usuario digita ou cola.
 *
 * Diferente da [zeroMask], NAO completa com zeros a esquerda e NAO trunca em um
 * tamanho fixo: mantem exatamente o que o usuario digitou, inclusive zeros a
 * esquerda (ex.: "001"). Isso e necessario porque o backend guarda esses campos
 * como texto e ja existem registros com zeros a esquerda.
 *
 * Uso:
 * <input type="text" pInputText digitsOnly inputmode="numeric" [(ngModel)]="form.timbrado" />
 */
@Directive({
    selector: '[digitsOnly]'
})
export class DigitsOnlyDirective {

    constructor(
        private el: ElementRef<HTMLInputElement>,
        @Optional() @Self() private model: NgModel | null
    ) { }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;
        const somenteDigitos = valorDigitado.replace(/\D/g, '');

        // Nada foi descartado: mantem o valor e o cursor como estao.
        if (somenteDigitos === valorDigitado) {
            return;
        }

        // Recua o cursor pela quantidade de caracteres invalidos removidos antes
        // dele, para nao "pular" quando o usuario edita no meio do valor.
        const cursorPos = input.selectionStart ?? valorDigitado.length;
        const invalidosAntesDoCursor = valorDigitado.slice(0, cursorPos).replace(/\d/g, '').length;
        const novoCursor = Math.max(0, cursorPos - invalidosAntesDoCursor);

        input.value = somenteDigitos;
        this.model?.viewToModelUpdate(somenteDigitos);
        input.setSelectionRange(novoCursor, novoCursor);
    }
}
